import { EnumWorkbench } from './workbench';
export const link = {
    ...EnumWorkbench,
};
